// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__2xqsQ","error":"InputSecondary_error__1h6vJ","disabled":"InputSecondary_disabled__3GL9i"};